import { Outlet } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Loading from './Loading'; // Import your loading component

const Sidebar = lazy(() => import('./SidebarCollapsed'));
//const Footer = lazy(() => import('./Footer'));

const Layout = (): JSX.Element => {
  console.log('🏢 AdminLayout renderizando...');
  
  return (
    <>
      <Suspense fallback={<Loading />}>
        <Sidebar>
          <Outlet />
        </Sidebar>
      </Suspense>
      {/* <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense> */}
    </>
  );
};

export default Layout;
